export const environment = {
    production: true,
    stage: 'prod',
    version: '1.0.0',
    lambdasUri: 'https://lambdas.mobydyg.com',
    lambdasApiKey: 'RnNWU0U1FUypwP3LxqbMWMQ5QzYaVXx46XiiquSGG3qj4oa5p804NTiqLzdk69SMQNHtzYuh95IkTeWU3WMBTcCOFzo5rGyj8x1N',
    cognitoUserPoolId : "us-east-1_nbsUBDYaE",
    cognitoAppClientId : "335g379jo2b0o14p0qhsbon25m",
    knowledgebaseUri: 'https://va-apis.crbytes.app',
    x_api_key: '!',
};
